import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface IService {
    serviceId: number;
    serviceName: string;
}

export interface IVessel {
    vesselId: number;
    vesselName: string;
}

@Injectable({
    providedIn: 'root'
})
export class CommonsService {
    private readonly baseUrl = `${environment.apiUrl}/v1/commons`;

    constructor(
        // eslint-disable-next-line no-unused-vars
        private http: HttpClient
    ) {}

    getServices(): Observable<IService[]> {
        return this.http.get<IService[]>(`${this.baseUrl}/services`);
    }

    getVessels(): Observable<IVessel[]> {
        return this.http.get<IVessel[]>(`${this.baseUrl}/vessels`);
    }
}
